export enum ETextLanguage {
    RU = 'ru',
    EN = 'en',
    UA = 'ua',
    ES = 'es',
    PT = 'pt',
    TR = 'tr',
    FR = 'fr',
    DE = 'de',
    IT = 'it',
    PL = 'pl',
}
